import React from 'react';
import { ApolloClient, createNetworkInterface, ApolloProvider } from 'react-apollo';
import { connect } from 'react-redux';

import { logoutUser } from '../../store/auth';
import Spinner from '../../components/Spinner';

import CoreLayout from './layouts/PageLayout/PageLayout';
import Home from './routes/Home';
import ProfileRoute from './routes/Profile';
import UniversityRoute from './routes/University';
import GetInvolvedRoute from './routes/GetInvolved';
import PreferencesRoute from './routes/Preferences';
import FeedbackRoute from './routes/Feedback';

const mapStateToProps = (state) => ({
  authedUserID: state.auth.sub || null,
  authedUser: state.auth || null,
});

export const createRoutes = (store) => {
  return ({
    path: 'advisor',
    component: connect(mapStateToProps)(props => {
      const ApolloNetworkInstance = createNetworkInterface({
        uri: __GraphQLProtected, // eslint-disable-line no-undef
        opts: {
          headers: {
            'Authorization': 'Bearer ' + props.authedUser.rawToken,
          }
        }
      });

      const ApolloClientInstance = new ApolloClient({
        networkInterface: ApolloNetworkInstance,
      });

      return (
        <ApolloProvider client={ApolloClientInstance}>
          <CoreLayout store={store} {...props} />
        </ApolloProvider>
      );
    }),
    indexRoute: Home(store),
    childRoutes: [
      ProfileRoute(store),
      UniversityRoute(store),
      GetInvolvedRoute(store),
      PreferencesRoute(store),
      FeedbackRoute(store),
      { // For Logging out the user
        path: 'logout',
        component: connect(
          mapStateToProps, {
            logoutUser,
          }
        )(class Logout extends React.Component {
          componentDidMount() {
            console.log(this.props);
            if (this.props.authedUserID !== null) {
              this.props.logoutUser();
            }

            window.location = (document.location.origin + '/advisor/');
          }

          render() {
            console.log(this.props);
            return (
              <Spinner />
            );
          }
        })
      },
    ]
  });
};

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routes/advisor/index.js